import { DeleteOutline, GridView } from '@mui/icons-material';
import { Box, Button, styled, Typography } from '@mui/material';
import { theme } from 'src/utils';

export const SectionsWrapper = styled(Box)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.divider};
  border-bottom: 1px solid ${theme.palette.divider};
  overflow-y: auto;
`,
);

const BaseWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const SectionContainer = styled(BaseWrapper)`
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px;

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.palette.divider};
  }
`;

export const SectionContentWrapper = styled(BaseWrapper)`
  align-items: center;
  height: 60px;
`;

export const SectionNameWrapper = styled(BaseWrapper)`
  align-items: center;
  gap: 12px;
`;

export const StyledGridViewIcon = styled(GridView)`
  color: #42474e;
`;

export const SectionNameContainer = styled(BaseWrapper)`
  flex-direction: column;
`;

export const SectionName = styled(Typography)`
  font-size: 15px;
  color: #181c20;
`;

export const SectionDescription = styled(Typography)`
  color: rgba(24, 28, 32, 0.6);
`;

export const StyledDeleteIcon = styled(DeleteOutline)`
  cursor: pointer;
  color: rgba(24, 28, 32, 0.6);
`;

export const ScheduleComponentButton = styled(Button)`
  width: 100%;
  height: 42px;
`;
